<ng-template
	#financialMovementCard
	let-row>
	<div class="eif-card">
		<div class="eif-card-header">
			<div class="label">{{ 'financial-movements.paymentRegistrationDate' | translate }}</div>
			<div>{{ row.PaymentRegistrationDate | dateLocale: 'yyyy/MM/dd' || '-' }}</div>
		</div>
		<div class="eif-card-section">
			<div class="label">{{ 'financial-movements.movementValueDate' | translate }}</div>
			<div>{{ row.MovementValueDate | dateLocale: 'yyyy/MM/dd' || '-' }}</div>
		</div>
		<div class="eif-card-section">
			<div class="label">{{ 'financial-movements.accumulatedAmount' | translate }}</div>
			<div class="is-bold">{{ row.DocumentMovementAccumulatedAmount | currencyLocale: aggregateDocument?.Document?.Currency || '-' }}</div>
		</div>
		<div class="eif-card-section">
			<div class="label">{{ 'financial-movements.amountWithVat' | translate }}</div>
			<div class="is-bold">{{ row.EffectivePaymentValue | currencyLocale: aggregateDocument?.Document?.Currency || '-' }}</div>
		</div>
		<div class="eif-card-section">
			<div class="label">{{ 'financial-movements.paymentNumber' | translate }}</div>
			<div>{{ row.FinancierPaymentNumber || '-' }}</div>
		</div>
		<div class="eif-card-section">
			<div class="label">{{ 'financial-movements.paymentMethod' | translate }}</div>
			<div>{{ row.FinancierPaymentMethod || '-' }}</div>
		</div>
		<div class="eif-card-section">
			<div class="label">{{ 'financial-movements.buyerIBAN' | translate }}</div>
			<div>{{ row.BuyerIban || '-' }}</div>
		</div>
		<div class="eif-card-section">
			<div class="label">{{ 'financial-movements.financierReference' | translate }}</div>
			<div>{{ row.BankMovementReference || '-' }}</div>
		</div>
		<div class="eif-card-section">
			<div class="label">{{ 'financial-movements.processingMethod' | translate }}</div>
			<div>{{ row.FinancierProcessingMode || '-' }}</div>
		</div>
	</div>
</ng-template>

<eif-custom-table
	#customTable
	[columns]="columns"
	[rows]="financialMovementsResult"
	[loading]="false"
	[pagination]="tablePagination"
	[identifier]="'financial-movements'"
	[pathPattern]="'/financial-movements'"
	(searchRequested)="onSearchRequested($event)"
	[userTimeZone]="loggedUser?.TimeZone || 'UTC'"
	[showPagination]="true"
	[cardTemplate]="financialMovementCard"
	[isLifecycleTable]="true">
</eif-custom-table>
